import { useCallback, useRef, useState } from 'react';
import ServiceTestsScheduleDialog from './ServiceTestsScheduleDialog';

export function useServiceTestsDialogs() {
    const [scheduleDialogOpen, setScheduleDialogOpen] = useState(false);
    const [scheduling, setScheduling] = useState(undefined);
    const [typeScheduling, setTypeScheduling] = useState(undefined);
    const refresherRef = useRef(null);
    const updateHandlerCallbackRef = useRef(null);

    const showScheduleDialogOpen = useCallback((initScheduling, initTypeScheduling, initUpdateHandlerCallback) => {
        setScheduling(initScheduling);
        setTypeScheduling(initTypeScheduling);
        updateHandlerCallbackRef.current = initUpdateHandlerCallback;
        setScheduleDialogOpen(true);
    }, []);

    const dialogElements = scheduleDialogOpen && (
        <ServiceTestsScheduleDialog
            open={scheduleDialogOpen}
            setOpen={setScheduleDialogOpen}
            scheduling={scheduling}
            typeScheduling={typeScheduling}
            updateHandlerCallbackRef={updateHandlerCallbackRef}
        />
    );

    return {
        dialogElements,
        showScheduleDialogOpen,
        refresherRef,
    };
}
